var map = {
	"./Approved.svg": 3818,
	"./AwaitingParts.svg": 3819,
	"./Closed.svg": 3820,
	"./Completed.svg": 3821,
	"./Excel.svg": 3822,
	"./Exportall_grey.svg": 3823,
	"./Exportall_grey_circle.svg": 3824,
	"./InProgress.svg": 3825,
	"./New.svg": 3826,
	"./View_Pic_Grey.svg": 3827,
	"./accident.svg": 3828,
	"./account.svg": 3829,
	"./addOrange.svg": 3830,
	"./addUser.svg": 3831,
	"./addVehicle.svg": 3832,
	"./address.svg": 3833,
	"./alert.svg": 3834,
	"./all_active.svg": 3835,
	"./all_active_es.svg": 3836,
	"./arrow-down.svg": 3837,
	"./arrow-up.svg": 3838,
	"./arrowRight.svg": 3839,
	"./awaiting_parts_grey.svg": 3840,
	"./awaiting_parts_orange.svg": 3841,
	"./back-btn.svg": 3842,
	"./back-button-grey.svg": 3843,
	"./backButton.svg": 3844,
	"./bills_of_landing_active.svg": 3845,
	"./bills_of_landing_active_es.svg": 3846,
	"./bobTail.svg": 3847,
	"./book-solid.svg": 3848,
	"./boxTruck.svg": 3849,
	"./calanderIcon.svg": 3850,
	"./cameraSelected.svg": 3851,
	"./camera_selected.svg": 3852,
	"./chat-icon.svg": 3853,
	"./circle-Exportall_grey.svg": 3854,
	"./circle-export.svg": 3855,
	"./circle-exportUser.svg": 3856,
	"./circle-import.svg": 3857,
	"./circle-importUser.svg": 3858,
	"./circle-viewall.svg": 3859,
	"./clearAll.svg": 3860,
	"./close-popup.svg": 3861,
	"./closeMap.svg": 3862,
	"./closed-Orange.svg": 3863,
	"./closed-grey.svg": 3864,
	"./clusterIcon.svg": 3865,
	"./communication_records_active.svg": 3866,
	"./communication_records_active_es.svg": 3867,
	"./company.svg": 3868,
	"./companyIcon.svg": 3869,
	"./complete-Orange.svg": 3870,
	"./complete-grey.svg": 3871,
	"./csa.svg": 3872,
	"./csaSnapshot.svg": 3873,
	"./dailyDocuments.svg": 3874,
	"./dashboard.svg": 3875,
	"./dashboardIcon.svg": 3876,
	"./date.svg": 3877,
	"./delete.svg": 3878,
	"./deleteCircle.svg": 3879,
	"./delivery_receipts_active.svg": 3880,
	"./delivery_receipts_active_es.svg": 3881,
	"./departments.svg": 3882,
	"./departmetEdit.svg": 3883,
	"./developer.svg": 3884,
	"./direction.svg": 3885,
	"./dispatch_records_active.svg": 3886,
	"./dispatch_records_active_es.svg": 3887,
	"./document.svg": 3888,
	"./documents.svg": 3889,
	"./dot.svg": 3890,
	"./dotAudit.svg": 3891,
	"./dotauditIcon.svg": 3892,
	"./downarrowIcon.svg": 3893,
	"./download.svg": 3894,
	"./downloadCenter.svg": 3895,
	"./downloadCenterMenu.svg": 3896,
	"./driver-behaviour.svg": 3897,
	"./driver.svg": 3898,
	"./dryVan.svg": 3899,
	"./dtc.svg": 3900,
	"./dualCam.svg": 3901,
	"./dump.svg": 3902,
	"./edit.svg": 3903,
	"./editLogIcon.svg": 3904,
	"./editSvg.svg": 3905,
	"./en.svg": 3906,
	"./es.svg": 3907,
	"./excelNew.svg": 3908,
	"./export-grey.svg": 3909,
	"./export.svg": 3910,
	"./exportUser.svg": 3911,
	"./feedback.svg": 3912,
	"./file-pdf-regular.svg": 3913,
	"./filter.svg": 3914,
	"./flatBed.svg": 3915,
	"./fleet.svg": 3916,
	"./fleetCompanies.svg": 3917,
	"./fleetdriverIcon.svg": 3918,
	"./fleetvehiclesIcon.svg": 3919,
	"./fletBed.svg": 3920,
	"./fr.svg": 3921,
	"./fuel.svg": 3922,
	"./full.svg": 3923,
	"./hamburger.svg": 3924,
	"./help-icon.svg": 3925,
	"./historyLogs.svg": 3926,
	"./icon-delete.svg": 3927,
	"./icon-export.svg": 3928,
	"./icon-menu-logs.svg": 3929,
	"./ifta.svg": 3930,
	"./import.svg": 3931,
	"./importUser.svg": 3932,
	"./in_progress_grey.svg": 3933,
	"./in_progress_orange.svg": 3934,
	"./infoTruck.svg": 3935,
	"./inspection-dvir.svg": 3936,
	"./inspection.svg": 3937,
	"./key.svg": 3938,
	"./leftArrow.svg": 3939,
	"./location.svg": 3940,
	"./locationMap.svg": 3941,
	"./log.svg": 3942,
	"./logEdit.svg": 3943,
	"./logHistory.svg": 3944,
	"./logoutIcon.svg": 3945,
	"./logs.svg": 3946,
	"./logsIcon.svg": 3947,
	"./mack.svg": 3948,
	"./mail.svg": 3949,
	"./main_camera.svg": 3950,
	"./mappinPopup.svg": 3951,
	"./menu_companies.svg": 3952,
	"./menu_dailyLog.svg": 3953,
	"./menu_reports.svg": 3954,
	"./menu_reseller.svg": 3955,
	"./menu_vehicle.svg": 3956,
	"./messageSender.svg": 3957,
	"./messaging.svg": 3958,
	"./new_login.svg": 3959,
	"./ninePin.svg": 3960,
	"./nonEdit.svg": 3961,
	"./notFull.svg": 3962,
	"./not_started_grey.svg": 3963,
	"./not_started_orange.svg": 3964,
	"./otherTrailer.svg": 3965,
	"./otherTruck.svg": 3966,
	"./other_documents_active.svg": 3967,
	"./other_documents_active_es.svg": 3968,
	"./overview.svg": 3969,
	"./page-first.svg": 3970,
	"./page-last.svg": 3971,
	"./page-next.svg": 3972,
	"./page-prev.svg": 3973,
	"./phone.svg": 3974,
	"./pickup.svg": 3975,
	"./pneumaticTrailer.svg": 3976,
	"./policy.svg": 3977,
	"./popupClose.svg": 3978,
	"./popupConfirm.svg": 3979,
	"./popupDelete.svg": 3980,
	"./privatePassenger.svg": 3981,
	"./qbdii.svg": 3982,
	"./receipts_active.svg": 3983,
	"./receipts_active_es.svg": 3984,
	"./reeferTrailer.svg": 3985,
	"./refreshCircle.svg": 3986,
	"./renewal.svg": 3987,
	"./repair.svg": 3988,
	"./reportIcon.svg": 3989,
	"./reports.svg": 3990,
	"./save-regular.svg": 3991,
	"./scoreCard.svg": 3992,
	"./searchGrey.svg": 3993,
	"./selectedConnection.svg": 3994,
	"./share.svg": 3995,
	"./sixPin.svg": 3996,
	"./sort.svg": 3997,
	"./speedometer.svg": 3998,
	"./spotlightGreen.svg": 3999,
	"./spotlightGrey.svg": 4000,
	"./spotlightRed.svg": 4001,
	"./straightTruck.svg": 4002,
	"./supportIcon.svg": 4003,
	"./switch.svg": 4004,
	"./tankerTrailer.svg": 4005,
	"./tick.svg": 4006,
	"./time.svg": 4007,
	"./timePicker.svg": 4008,
	"./toggle-off.svg": 4009,
	"./toggle-on.svg": 4010,
	"./tools.svg": 4011,
	"./tractorDayCab.svg": 4012,
	"./tractorSleeper.svg": 4013,
	"./undelete.svg": 4014,
	"./unsaved.svg": 4015,
	"./update.svg": 4016,
	"./upload.svg": 4017,
	"./usdot.svg": 4018,
	"./user.svg": 4019,
	"./userprofileIcon.svg": 4020,
	"./users.svg": 4021,
	"./vacuumTrailer.svg": 4022,
	"./vacuumTruck.svg": 4023,
	"./van.svg": 4024,
	"./vehicle-behaviour.svg": 4025,
	"./vehicle.svg": 4026,
	"./vehicleIcon.svg": 4027,
	"./viewArrow.svg": 4028,
	"./viewDocument.svg": 4029,
	"./viewReports.svg": 4030,
	"./viewStatus.svg": 4031,
	"./viewallMap.svg": 4032,
	"./violation.svg": 4033,
	"./volvo.svg": 4034,
	"./weigh_tickets_active.svg": 4035,
	"./weigh_tickets_active_es.svg": 4036,
	"./whitecheck_new.svg": 4037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3817;